
export class PostControlDocumentDto {
    postDocumentId;
    control;
    postControlInfo;
    postControlNote;

}


















